'use strict';//Indicating browser should run only in java script mode

//*******PURPOSE: The purpose of the controller is used for Date Selection
//*******EFFECTIVE FILES:EMRWEB/Common/CommonDateSelection.html
//*******CREATED BY:Rama M
//*******CREATED DATE:07/05/2016
//*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx


angular.module('EMR.Admin').directive('emrCommomDateSelection', function () {
    return ({
        restrict: 'AE',
        transclude: true,
        replace: true,
        templateUrl: GetEMRPageURLByPageName("EMRWEB/Common/CommonDateSelection.html"),//359
        controller: "CommonDateSelectionController",//controller to bind
        controllerAs: "vm", bindToController: true,//
        scope: {
            /* NOTE: Normally I would set my attributes and bindings
            to be the same name but I wanted to delineate between 
            parent and isolated scope. */
            //isolatedAttributeFoo:'@attributeFoo',
            //emrPatientChartOptions: '=options',//this is readed from the controller
            // isolatedExpressionFoo:'&'
        },

        link: {

            //this method executes when the link function has started
            pre: function preLink($scope, $iElement, $iAttrs, $controller) {

            },
            //after compilation/binding of the data has completed this method is executed
            post: function postLink($scope, $iElement, $iAttrs, $controller) {

                //on destroy clearing the events on nodes and removing the elements from the DOM
                $iElement.on('$destroy', function () {

                    ehrDirectiveElementsOnDestroyEvent($iElement);
                });

            }
        },
    })
}).controller('CommonDateSelectionController', ['$scope', 'ModalPopupService', 'CommonService', 'DashBoardService','EMRCommonFactory', function ($scope, ModalPopupService, CommonService, DashBoardService, EMRCommonFactory) {

    // angular 1.5 : lifecycle hook 
    this.$onInit = function () {
        $scope.commonDateSelectionPageInit();
    }

    //*******PURPOSE: PAGE INITTILIZATION METHOD START
    //*******CREATED BY:Rama M
    //*******CREATED DATE: 07/05/2016
    //*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
    $scope.commonDateSelectionPageInit = function () {
        $scope.commonDateSelectionGUID = adminGetGUID();
        $scope.commonDateSelectionGridWidgets = {};
        $scope.commonDateSelectionHeader = "Select Date";
        var commonDateSelectionCurrentDate = new Date(adminGetCurrentDate());
        $scope.commonDateSelectionCurrentYear = commonDateSelectionCurrentDate.getFullYear();
        if (hasValue($scope.$parent.EMRDataFromPopup) && hasValue($scope.$parent.EMRDataFromPopup.DOB)) {
            $scope.commonDateSelectionPatientDOB = $scope.$parent.EMRDataFromPopup.DOB;
        }
        //GETTING PATIENT DETAILS BASED ON PATIENTID
        if (hasValue($scope.$parent.EMRDataFromPopup) && hasValue($scope.$parent.EMRDataFromPopup.PatientID)) {
            //IF PATIENT DOB NOT AVAILABLE
            if (!hasValue($scope.$parent.EMRDataFromPopup.DOB)) {
                //CALLING METHOD TO GET PATIENT DETAILS
                $scope.commonDateSelectionGetPatientDetails();
            }

        }
        if (hasValue($scope.$parent.EMRDataFromPopup.headerText) && hasValue($scope.$parent.EMRDataFromPopup.headerText.trim().lenght > 0))
            $scope.commonDateSelectionHeader = "Select " + $scope.$parent.EMRDataFromPopup.headerText;


        $scope.commonDateSelectionDatesWidthClass = "col-md-8 colReq-sm-12";
        $scope.commonDateSelectionCalendarWidthClass = "col-md-4 colReq-sm-8";
        $scope.commonDateSelectionYearsAgoWidthClass = "col-md-3 colReq-sm-3";

        //METHOD TO GET ALL DATE DETAILS
        $scope.commonDateSelectionGetAllDateDetails();
        if(_.get($scope.$parent.EMRDataFromPopup,"isPopupOpenedFrom") == "PL") EMRCommonFactory.EHRSaveAuditLogInformation(EHRAuditLogXperEMR_Components.ProblemList, "Select Date Popup from PL", "Select Date Popup Opened", EHRAuditLogStatus.Success, EHRAuditLogActions.WINDOWOPEN, _.get($scope.$parent.EMRDataFromPopup,"PatientID"), EMRPracticeModel.LoggedUserID);
        //TO HIDE/SHOW THE AT AGE COLUMN IF THE PATIENT HAS NO DOB
        //if (!hasValue($scope.$parent.EMRDataFromPopup.DOB)) {
    };
    //#########  GET  PATIENT DETAILS  BLOCK START ##############
    //*******PURPOSE: THIS METHOD IS USED GET PATIENT DETAILS
    //*******CREATED BY:PHANI KUMAR M
    //*******CREATED DATE: 5 TH AUGUST 2016
    //*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; **********************************
    $scope.commonDateSelectionGetPatientDetails = function () {
        //DATA TO SERVICE
        var postData = {
            PersonID: $scope.$parent.EMRDataFromPopup.PatientID
        }
        DashBoardService.getPersonDetails(postData).then(function (serviceResponse) {
            if (isError(serviceResponse)) return;
            //CHEKING WHETHER DOB THERE OR NOT
            if (hasValue(serviceResponse.DateofBirth)) {
                //ONLY ASSIGNING DOB FROM SERVICE IF DOB NOT PASSSED
                if (!hasValue($scope.$parent.EMRDataFromPopup.DOB)) {
                    $scope.commonDateSelectionPatientDOB = serviceResponse.DateofBirth;
                }
            }
        });
    }
    //#########  GET  PATIENT DETAILS  BLOCK END ##############

    //#########  GET  ALL DATE SELECTION DETAILS LIST BLOCK START ##############
    //*******PURPOSE: THIS METHOD IS USED GET  ALL DATE SELECTION DETAILS LIST
    //*******CREATED BY:PHANI KUMAR M
    //*******CREATED DATE: 5 TH JULY 2016
    //*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; **********************************
    $scope.commonDateSelectionGetAllDateDetails = function () {

        //var ServiceData = {

        //};
        ////CALLING SERVIC ETO GET DETAILS
        //CommonService.commonServiceGetAllCommonDateControlLists(ServiceData).then(function (ServiceResponse) {
        //    //IF ANY ERROR THEN RETURN
        //    if (isError(ServiceResponse)) return;
        var ServiceResponse = {};
        /*here we are calling CommonAtAgesStaticListBuilding function for to get Common at ages list*/
        ServiceResponse.CommonAtAgesList = CommonAtAgesStaticListBuilding();
        /*here we are calling CommonYearsAgoStaticListBuilding function for to get Common Years Ago list*/
        ServiceResponse.CommonYearsAgoList = CommonYearsAgoStaticListBuilding();
        /*here we are calling CommonAtAgesStaticListBuilding function for to get Common Months  list*/
        ServiceResponse.CommonMonthsList = CommonMonthsStaticListBuilding();
        /*here we are calling CommonAtAgesStaticListBuilding function for to get Common Previous years list*/
        ServiceResponse.CommonPreviosYearsList = CommonPreviousYearsStaticListBuliding();
        if (hasValue(ServiceResponse)) {
            //CHECKING WHETHER AGES LIST THERE OR NOT
            if (hasValue(ServiceResponse.CommonAtAgesList) && ServiceResponse.CommonAtAgesList.length > 0) {
                $scope.commonDateSelectionAtAgeGridDataSource.data(ServiceResponse.CommonAtAgesList);

                if (!hasValue($scope.$parent.EMRDataFromPopup.DOB)) {
                    // ($scope.commonDateSelectionGridWidgets.grdCommonDateSelectionAtAgeGridInfo).hideColumn('AtAge');
                    if (hasValue($scope.$parent.EMRDataFromPopup.IsDOBThere) && $scope.$parent.EMRDataFromPopup.IsDOBThere == true) {
                        $scope.CommonDateSelectionShowHideAtAge = true;
                        $scope.commonDateSelectionDatesWidthClass = "col-md-8 colReq-sm-12";
                        $scope.commonDateSelectionCalendarWidthClass = "col-md-4 colReq-sm-8";
                        $scope.commonDateSelectionYearsAgoWidthClass = "col-md-3 colReq-sm-3";
                    } else {
                        $scope.CommonDateSelectionShowHideAtAge = false;
                        $scope.commonDateSelectionDatesWidthClass = "col-md-7 colReq-sm-12";
                        $scope.commonDateSelectionCalendarWidthClass = "col-md-5 colReq-sm-8";
                        $scope.commonDateSelectionYearsAgoWidthClass = "col-md-4 colReq-sm-3";
                    }
                }
                else {
                    // ($scope.commonDateSelectionGridWidgets.grdCommonDateSelectionAtAgeGridInfo).showColumn('AtAge');
                    $scope.CommonDateSelectionShowHideAtAge = true;
                    $scope.commonDateSelectionDatesWidthClass = "col-md-8 colReq-sm-12";
                    $scope.commonDateSelectionCalendarWidthClass = "col-md-4 colReq-sm-8";
                    $scope.commonDateSelectionYearsAgoWidthClass = "col-md-3 colReq-sm-3";

                }
            }
            //CHECKING WHETHER YEARS AGO LIST THERE OR NOT
            if (hasValue(ServiceResponse.CommonYearsAgoList) && ServiceResponse.CommonYearsAgoList.length > 0) {
                $scope.commonDateSelectionYearsAgoGridDataSource.data(ServiceResponse.CommonYearsAgoList);
            }
            //CHECKING WHETHER MONTHS LIST THERE OR NOT
            if (hasValue(ServiceResponse.CommonMonthsList) && ServiceResponse.CommonMonthsList.length > 0) {
                $scope.commonDateSelectionMonthGridDataSource.data(ServiceResponse.CommonMonthsList);
            }


            //WHEN OPENING FROM HM REMINDER DUES NAVIGATION ADDING + 10 YEARS TO CURRENT YEAR
            if (hasValue($scope.$parent.EMRDataFromPopup) && hasValue($scope.$parent.EMRDataFromPopup.ExtendUptoYears) && parseInt($scope.$parent.EMRDataFromPopup.ExtendUptoYears) > 0) {

                var ExtendUptoYearsInfo = $scope.$parent.EMRDataFromPopup.ExtendUptoYears;

                if (hasValue(ServiceResponse.CommonPreviosYearsList) && ServiceResponse.CommonPreviosYearsList.length > 0) {
                    //CURRENT LIST
                    var List = ServiceResponse.CommonPreviosYearsList;

                    var CurrentDate = new Date();

                    var CurrentYear = CurrentDate.getFullYear();

                    for (var index = 1; index <= ExtendUptoYearsInfo; index++) {

                        CurrentYear++;
                        List.unshift({ PreviousYear: CurrentYear });
                    }

                    if (hasValue(List) && List.length > 0) {
                        //BINDING CURRENT LIST AND = 10YRS LIST TO GRID
                        $scope.commonDateSelectionYearGridDataSource.data(List);
                    }

                }

            }
            else {
                //CHECKING WHETHER PREVIOUS YEARS LIST THERE OR NOT
                if (hasValue(ServiceResponse.CommonPreviosYearsList) && ServiceResponse.CommonPreviosYearsList.length > 0) {
                    $scope.commonDateSelectionYearGridDataSource.data(ServiceResponse.CommonPreviosYearsList);
                }
            }




        }
        // });
    };
    //#########  GET  ALL DATE SELECTION DETAILS LIST BLOCK END ##############
    /*This method is used to build Common At ages Static List*/
    var CommonAtAgesStaticListBuilding = function () {
        var CommonAtAgesList = [];
        for (var AtAgeIndex = 1; AtAgeIndex <= 70; AtAgeIndex++) {
            var CommonAtAgesModel = {
                AtAgeID: AtAgeIndex,
                AtAge: AtAgeIndex.toString(),
                SelectionType: 1,
            }
            CommonAtAgesList.push(CommonAtAgesModel);
        }
        return CommonAtAgesList;
    }
    /*This method is used to build Common Years Ago Static List*/
    var CommonYearsAgoStaticListBuilding = function () {
        var CommonYearsAgoList = []
        for (var yearsAgoIndex = 1; yearsAgoIndex <= 30; yearsAgoIndex++) {
            var CommonYearsAgoModel = {
                YearID: yearsAgoIndex,
                Year: yearsAgoIndex.toString(),
                SelectionType: 2,
            }
            CommonYearsAgoList.push(CommonYearsAgoModel);
        }
        return CommonYearsAgoList;
    }
    /*This method is used to build Common Months Static List*/
    var CommonMonthsStaticListBuilding = function () {
        var CommonMonthsList = [
            { MonthID: "01", Month: "January", SelectionType: 3 },
            { MonthID: "02", Month: "February", SelectionType: 3 },
            { MonthID: "03", Month: "March", SelectionType: 3 },
            { MonthID: "04", Month: "April", SelectionType: 3 },
            { MonthID: "05", Month: "May", SelectionType: 3 },
            { MonthID: "06", Month: "June", SelectionType: 3 },
            { MonthID: "07", Month: "July", SelectionType: 3 },
            { MonthID: "08", Month: "August", SelectionType: 3 },
            { MonthID: "09", Month: "September", SelectionType: 3 },
            { MonthID: "10", Month: "October", SelectionType: 3 },
            { MonthID: "11", Month: "November", SelectionType: 3 },
            { MonthID: "12", Month: "December", SelectionType: 3 },
        ];
        return CommonMonthsList;

    }
    //changes done by bharath.gourisetti on 8dec2021, As per task 3162 need to increment one year when its in december month
    //according to js there will be 0 to 11 in months so incremented 1 for equevalent to dec month.
    //condition applied weather in dec then increment 1 year other wise considers current year.
    /*This method is used to build Common  Previous year  Static List*/
    var CommonPreviousYearsStaticListBuliding = function () {
        var CommonPreviousYearsList = [];
        var CurrentDate = new Date();
        var CurrentMonthID = CurrentDate.getMonth() + 1;
        var CurrentYear = (CurrentMonthID == 12) ? CurrentDate.getFullYear() + 1 : CurrentDate.getFullYear();

        //CHECKING WHETHER THE YEAR VALUE IS GREATER THAN ZERO OR NOT
        //IF THE YEAR VALUE IS GREATER THAN ZERO THEN LOOPING THE VALUES AND ADD THOSE VALUES TO THE DATACLASS.
        if (CurrentYear > 0) {
            //FOR LOOP FOR GETTING THE LAST 40 YEARS WHICH IS USED TO POPULATE IN THE LIST BOX OF THE PROBLEM LIST WINDOW.
            for (var PreviousYearIndex = 1; PreviousYearIndex <= 25; PreviousYearIndex++) {

                var CommonPreviousYearModel = {
                    PreviousYearID: PreviousYearIndex,
                    PreviousYear: (CurrentYear - (PreviousYearIndex - 1)).toString(),
                    SelectionType: 4,
                };

                //ADDING THE DATACLASS OBJECT TO THE LIST ITEM.
                CommonPreviousYearsList.push(CommonPreviousYearModel);
            }
        }
        return CommonPreviousYearsList;
    }
    //##################################################### AT AGE SELECTION GRID BLOCK START ##########################################
    //INITIALIZING DATA SOURCE
    $scope.commonDateSelectionAtAgeGridDataSource = new kendo.data.DataSource({
        data: [],//assigning the  on default
    });
    //GRID OPTIONS
    $scope.commonDateSelectionAtAgeGridOptions = {
        dataSource: $scope.commonDateSelectionAtAgeGridDataSource,//assigning the data source
        sortable: true,
        navigatable: true,
        selectable: "single row",
        columns: [

            {
                field: 'AtAge',
                title: 'At Age',
                attributes: { "class": "gridImageAlign" },
                // hidden:true,
            },
        ],
    };

    //######### AT AGE SELECTION GRID DATABOUND BLOCK START ##############
    //*******PURPOSE: THIS METHOD IS USED BIND GRID DATA 
    //*******CREATED BY:PHANI KUMAR M
    //*******CREATED DATE: 6 TH JULY 2016
    //*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; **********************************
    $scope.commonDateSelectionAtAgeGridOptions.dataBound = function (e) {
        kendoGridEmptyDataTemplate(this, '', '');
        var grid = e.sender;
        if (grid.dataSource.data().length > 0) {
            grid.table.attr("tabindex", 140703);
        }


    };
    //######### AT AGE SELECTION GRID DATABOUND BLOCK END ##############

    //######### AT AGE SELECTION GRID CHANGE BLOCK START ##############
    //*******PURPOSE: THIS METHOD IS USED PERFORM NECESSARY ACTION ON CHANGE EVENTS
    //*******CREATED BY:PHANI KUMAR M
    //*******CREATED DATE: 6 TH JULY 2016
    //*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; **********************************
    $scope.commonDateSelectionAtAgeGridOptions.change = function (e) {
        $scope.commonDateSelectionAtAgeselectedItem = [];
        //DECLARING VARIABLES
        var commonDateSelectionSelectedDate = "";

        //IF ANY PREVIOUS ITEM SELECTED THEN REMOVING SELECTED ITEM AND ITS FOCUS
        if (hasValue($scope.PreviousSelectedItem) && hasValue($scope.PreviousSelectedItem.uid) && hasValue($scope.PreviousSelectedGrid) && $scope.PreviousSelectedItem.SelectionType != 1) {
            //if ($scope.PreviousSelectedGrid.table.find("tr[data-uid='" + $scope.PreviousSelectedItem.uid + "']").hasClass("k-state-selected")) {
            $scope.PreviousSelectedGrid.table.find("tr[data-uid='" + $scope.PreviousSelectedItem.uid + "']").removeClass("k-state-selected");//removing the state selected
            $scope.PreviousSelectedGrid.table.find("tr[data-uid='" + $scope.PreviousSelectedItem.uid + "']").children().removeClass("k-state-focused")//removing the state Focussed
            $scope.PreviousSelectedItem = [];
            $scope.PreviousSelectedGrid = {};

            // }
        }
        //IF ANY PREVIOUS MONTH ITEM SELECTED THEN REMOVING SELECTED ITEM AND ITS FOCUS

        if (hasValue($scope.PreviousSelectedMonthItem) && hasValue($scope.PreviousSelectedMonthItem.uid) && hasValue($scope.PreviousSelectedMonthGrid)) {
            //if ($scope.PreviousSelectedMonthItem.table.find("tr[data-uid='" + $scope.PreviousSelectedMonthItem.uid + "']").hasClass("k-state-selected")) {
            $scope.PreviousSelectedMonthGrid.table.find("tr[data-uid='" + $scope.PreviousSelectedMonthItem.uid + "']").removeClass("k-state-selected");//removing the state selected
            $scope.PreviousSelectedMonthGrid.table.find("tr[data-uid='" + $scope.PreviousSelectedMonthItem.uid + "']").children().removeClass("k-state-focused")//removing the state Focussed
            $scope.PreviousSelectedMonthItem = [];
            $scope.PreviousSelectedMonthGrid = {};

            // }
        }

        //ASSIGNING WIDGETS AND GETTING GRID OBJECT
        var grid = $scope.commonDateSelectionGridWidgets.grdCommonDateSelectionAtAgeGridInfo;
        //GETTING SELECTED ITEM
        $scope.commonDateSelectionAtAgeselectedItem = grid.dataItem(grid.select());
        //IF PATIENT DOB NOT AVAILABLE THEN RETURN
        if (!hasValue($scope.commonDateSelectionPatientDOB)) return;
        //CHEKING WHTHER AGE SLECTED OR NOT
        if (hasValue($scope.commonDateSelectionAtAgeselectedItem) && hasValue($scope.commonDateSelectionAtAgeselectedItem.AtAgeID) && $scope.commonDateSelectionAtAgeselectedItem.AtAgeID > 0) {
            //ADDING SELECTED AGE TO DOB AND GETTING SLECTED DATE
            commonDateSelectionSelectedDate = $.format.date(new Date($scope.commonDateSelectionPatientDOB).addYears($scope.commonDateSelectionAtAgeselectedItem.AtAgeID), "MM/dd/yyyy");
        }

        if (hasValue($scope.$parent.EMRDataFromPopup) && hasValue($scope.$parent.EMRDataFromPopup.isAllowFutureDate) && $scope.$parent.EMRDataFromPopup.isAllowFutureDate == true) {

            //CHECKING WHETHER SELECTED DATE IS GREATER THAN CURRENT DATE OR NOT
            if (DateDiff.inDays($.format.date(commonDateSelectionSelectedDate, "MM/dd/yyyy"), adminCurrentDateAndTme) >= 0) {
                // ShowErrorMessage("Selected Age Should be Less than or Equal to Date of Birth (" + $scope.commonDateSelectionPatientDOB + ")");
                ShowErrorMessage("Selected Age (" + commonDateSelectionSelectedDate + ") Should be Greater than Current Date.");
                $scope.PreviousSelectedItem = $scope.commonDateSelectionAtAgeselectedItem;
                $scope.PreviousSelectedGrid = grid;
                return false;
            }
        }
        else {
            //CHECKING WHETHER SELECTED DATE IS GREATER THAN CURRENT DATE OR NOT
            if (DateDiff.inDays($.format.date(commonDateSelectionSelectedDate, "MM/dd/yyyy"), adminCurrentDateAndTme) < 0) {
                if (hasValue($scope.$parent.EMRDataFromPopup) && hasValue($scope.$parent.EMRDataFromPopup.IsDOBThere)) {
                    ShowErrorMessage("Selected Age Should be Less than or Equal to Patient's Age");
                } else {
                    ShowErrorMessage("Selected Age Should be Less than or Equal to Date of Birth (" + $scope.commonDateSelectionPatientDOB + ")");
                }
                $scope.PreviousSelectedItem = $scope.commonDateSelectionAtAgeselectedItem;
                $scope.PreviousSelectedGrid = grid;
                return false;
            }
            //CHEKING WHETHER SELECTED DATE IS FUTURE DATE OR NOT
            if (DateDiff.inDays($.format.date(commonDateSelectionSelectedDate, "MM/dd/yyyy"), $scope.commonDateSelectionPatientDOB) > 0) {

                if (hasValue($scope.$parent.EMRDataFromPopup) && hasValue($scope.$parent.EMRDataFromPopup.IsDOBThere)) {
                    ShowErrorMessage("Selected Age Should be Less than or Equal to Patient's Age");
                } else {
                    ShowErrorMessage("Selected Age Should be Less than or Equal to Date of Birth (" + $scope.commonDateSelectionPatientDOB + ")");
                }
                $scope.PreviousSelectedItem = $scope.commonDateSelectionAtAgeselectedItem;
                $scope.PreviousSelectedGrid = grid;
                return false;
            }
        }
        //PASSING SELECTED DETAILS AS RESULT
        var SelectedAtAgeData = {
            SelectedDate: commonDateSelectionSelectedDate,
            SelectionType: 1
        };
        formatSelectedValueAndClose(SelectedAtAgeData); //Format the selected value and pass as parameter when closing popup
    };
    //######### AT AGE SELECTION GRID CHANGE BLOCK END ##############

    //##################################################### AT AGE SELECTION GRID BLOCK END ##########################################

    //#####################################################YEARS AGO SELECTION GRID BLOCK START ##########################################
    //INITIALIZING DATA SOURCE
    $scope.commonDateSelectionYearsAgoGridDataSource = new kendo.data.DataSource({
        data: []//assigning the  on default
    });
    //GRID OPTIONS
    $scope.commonDateSelectionYearsAgoGridOptions = {
        dataSource: $scope.commonDateSelectionYearsAgoGridDataSource,//assigning the data source
        sortable: true,
        navigatable: true,
        selectable: "single row",
        columns: [

            {
                field: 'Year',
                title: 'Yrs Ago',
                attributes: { "class": "gridImageAlign" },
            },
        ],
    };

    //######### YEARS AGO SELECTION GRID DATABOUND BLOCK START ##############
    //*******PURPOSE: THIS METHOD IS USED BIND GRID DATA 
    //*******CREATED BY:PHANI KUMAR M
    //*******CREATED DATE: 6 TH JULY 2016
    //*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; **********************************
    $scope.commonDateSelectionYearsAgoGridOptions.dataBound = function (e) {
        kendoGridEmptyDataTemplate(this, '', '');
        var grid = e.sender;
        if (grid.dataSource.data().length > 0) {
            grid.table.attr("tabindex", 140703);
        }

    };
    //######### YEARS AGO SELECTION GRID DATABOUND BLOCK END ##############

    //######### YEARS AGO SELECTION GRID CHANGE BLOCK START ##############
    //*******PURPOSE: THIS METHOD IS USED PERFORM NECESSARY ACTION ON CHANGE EVENTS
    //*******CREATED BY:PHANI KUMAR M
    //*******CREATED DATE: 6 TH JULY 2016
    //*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; **********************************
    $scope.commonDateSelectionYearsAgoGridOptions.change = function (e) {

        $scope.commonDateSelectionYearsAgoSelectedItem = [];
        //DECLARING VARIABLES
        var commonDateSelectionSelectedDate = "";
        var commonDateSelectionSelectedDateDisplayText = "";
        //IF ANY PREVIOUS ITEM SELECTED THEN REMOVING SELECTED ITEM AND ITS FOCUS
        if (hasValue($scope.PreviousSelectedItem) && hasValue($scope.PreviousSelectedItem.uid) && hasValue($scope.PreviousSelectedGrid) && $scope.PreviousSelectedItem.SelectionType != 2) {
            //if ($scope.PreviousSelectedGrid.table.find("tr[data-uid='" + $scope.PreviousSelectedItem.uid + "']").hasClass("k-state-selected")) {
            $scope.PreviousSelectedGrid.table.find("tr[data-uid='" + $scope.PreviousSelectedItem.uid + "']").removeClass("k-state-selected");//removing the state selected
            $scope.PreviousSelectedGrid.table.find("tr[data-uid='" + $scope.PreviousSelectedItem.uid + "']").children().removeClass("k-state-focused")//removing the state Focussed
            $scope.PreviousSelectedItem = [];
            $scope.PreviousSelectedGrid = {};
            // }

        }
        //IF ANY PREVIOUS MONTH ITEM SELECTED THEN REMOVING SELECTED ITEM AND ITS FOCUS
        if (hasValue($scope.PreviousSelectedMonthItem) && hasValue($scope.PreviousSelectedMonthItem.uid) && hasValue($scope.PreviousSelectedMonthGrid)) {
            $scope.PreviousSelectedMonthGrid.table.find("tr[data-uid='" + $scope.PreviousSelectedMonthItem.uid + "']").removeClass("k-state-selected");//removing the state selected
            $scope.PreviousSelectedMonthGrid.table.find("tr[data-uid='" + $scope.PreviousSelectedMonthItem.uid + "']").children().removeClass("k-state-focused")//removing the state Focussed
            $scope.PreviousSelectedMonthItem = [];
            $scope.PreviousSelectedMonthGrid = {};

        }
        //GETTING GRID OBJECT
        var grid = $scope.commonDateSelectionGridWidgets.grdCommonDateSelectionYearsAgoGridInfo;
        //GETTING SELECTED ITEM
        $scope.commonDateSelectionYearsAgoSelectedItem = grid.dataItem(grid.select());

        if (hasValue($scope.$parent.EMRDataFromPopup) && hasValue($scope.$parent.EMRDataFromPopup.isAllowFutureDate) && $scope.$parent.EMRDataFromPopup.isAllowFutureDate == true) {
            ShowErrorMessage("Years Ago Should not be Applicable for Future Date.");
            $scope.PreviousSelectedItem = $scope.commonDateSelectionYearsAgoSelectedItem;
            $scope.PreviousSelectedGrid = grid;
            return false;
        }

        //GETTING SELECTED YEARS AGO 
        var commonDateSelectionYearsAgo = $scope.commonDateSelectionYearsAgoSelectedItem.YearID;
        //GETTING YEAR FROM SELECTED YEARS AGO
        var commonDateSelectionSelectedStratDate = $scope.commonDateSelectionCurrentYear - commonDateSelectionYearsAgo;
        //FORMING FULL DATE
        commonDateSelectionSelectedDate = "1/1/" + commonDateSelectionSelectedStratDate;
        //DISPLAY TEXT
        commonDateSelectionSelectedDateDisplayText = commonDateSelectionSelectedStratDate;

        var commonDateSelectionPtDOBYear = parseInt(adminGetDateInyearFormat($scope.commonDateSelectionPatientDOB));
        if ((commonDateSelectionPtDOBYear - commonDateSelectionSelectedStratDate) > 0) {
            ShowErrorMessage("Yrs Ago Should be Less than or Equal to the Date of Birth (" + $scope.commonDateSelectionPatientDOB + ")");
            $scope.PreviousSelectedItem = $scope.commonDateSelectionYearsAgoSelectedItem;
            $scope.PreviousSelectedGrid = grid;
            return;
        }

        //ASSIGNING SELECTED DATA TO OBJECT TO RETURN
        var YearsAgoSelectedData = {
            SelectedDate: commonDateSelectionSelectedDate,
            SelectedDateDisplayText: commonDateSelectionSelectedDateDisplayText,
        }
        //CHECKING WHETHER SELECTION TYPE THERE OR NOT
        if (hasValue($scope.commonDateSelectionYearsAgoSelectedItem) && hasValue($scope.commonDateSelectionYearsAgoSelectedItem.SelectionType) && $scope.commonDateSelectionYearsAgoSelectedItem.SelectionType > 0) {
            YearsAgoSelectedData.SelectionType = $scope.commonDateSelectionYearsAgoSelectedItem.SelectionType;
        }
        else {
            YearsAgoSelectedData.SelectionType = 2// FO RYEARS AGO TYPE -2
        }
        formatSelectedValueAndClose(YearsAgoSelectedData); //Format the selected value and pass as parameter when closing popup
    };
    //######### YEARS AGO SELECTION GRID CHANGE BLOCK END ##############

    //#####################################################YEARS AGO SELECTION GRID BLOCK END ##########################################


    //##################################################### MONTH SELECTION GRID BLOCK START ##########################################

    //INITIALIZING  GRI DATA SOURCE
    $scope.commonDateSelectionMonthGridDataSource = new kendo.data.DataSource({
        data: []//assigning the  on default
    });
    //MONTH GRID OPTIONS
    $scope.commonDateSelectionMonthGridOptions = {
        dataSource: $scope.commonDateSelectionMonthGridDataSource,//assigning the data source
        sortable: true,
        navigatable: true,
        selectable: "single row",
        columns: [

            {
                field: 'Month',
                title: 'Month',
                attributes: { "class": "gridImageAlign" },
            },
        ],
    };

    //######### MONTH SELECTION GRID DATABOUND BLOCK START ##############
    //*******PURPOSE: THIS METHOD IS USED BIND GRID DATA 
    //*******CREATED BY:PHANI KUMAR M
    //*******CREATED DATE: 6 TH JULY 2016
    //*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; **********************************
    $scope.commonDateSelectionMonthGridOptions.dataBound = function (e) {
        kendoGridEmptyDataTemplate(this, '', '');
        var grid = e.sender;
        if (grid.dataSource.data().length > 0) {
            grid.table.attr("tabindex", 140703);
        }

    };
    //######### MONTH SELECTION GRID DATABOUND BLOCK END ##############

    //######### MONTH SELECTION GRID CHANGE BLOCK START ##############
    //*******PURPOSE: THIS METHOD IS USED PERFORM NECESSARY ACTION ON CHANGE EVENTS
    //*******CREATED BY:PHANI KUMAR M
    //*******CREATED DATE: 6 TH JULY 2016
    //*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; **********************************
    $scope.commonDateSelectionMonthGridOptions.change = function (e) {
        $scope.commonDateSelectionMonthSelectedItem = [];
        //GETTING GRID OBJECT
        var grid = $scope.commonDateSelectionGridWidgets.grdCommonDateSelectionMonthGridInfo;
        //GETTING SELECTED ITEM
        $scope.commonDateSelectionMonthSelectedItem = grid.dataItem(grid.select());
        //$scope.PreviousSelectedItem = $scope.commonDateSelectionMonthSelectedItem;
        //$scope.PreviousSelectedGrid = grid;        //CALLING METHOD TO BUILD SELECTED DATE DETAILS
        $scope.commonDateSelectionGetSelectedMonthAndYearDetails(grid, false);
    };
    //######### MONTH SELECTION GRID CHANGE BLOCK END ##############

    //##################################################### MONTH SELECTION GRID BLOCK END ##########################################

    //##################################################### YEAR SELECTION GRID BLOCK START ##########################################
    //INITIALIZING DATA SOURCE
    $scope.commonDateSelectionYearGridDataSource = new kendo.data.DataSource({
        data: []//assigning the  on default
    });
    //GRID OPTIONS
    $scope.commonDateSelectionYearGridOptions = {
        dataSource: $scope.commonDateSelectionYearGridDataSource,//assigning the data source
        sortable: true,
        navigatable: true,
        selectable: "single row",
        columns: [

            {
                field: 'PreviousYear',
                title: 'Year',
                attributes: { "class": "gridImageAlign" },
            },
        ],
    };

    //######### YEAR SELECTION GRID DATABOUND BLOCK START ##############
    //*******PURPOSE: THIS METHOD IS USED BIND GRID DATA 
    //*******CREATED BY:PHANI KUMAR M
    //*******CREATED DATE: 6 TH JULY 2016
    //*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; **********************************
    $scope.commonDateSelectionYearGridOptions.dataBound = function (e) {
        kendoGridEmptyDataTemplate(this, '', '');
        var grid = e.sender;
        if (grid.dataSource.data().length > 0) {
            grid.table.attr("tabindex", 140703);
        }

    };
    //######### YEAR SELECTION GRID DATABOUND BLOCK END ##############

    //######### YEAR SELECTION GRID CHANGE BLOCK START ##############
    //*******PURPOSE: THIS METHOD IS USED PERFORM NECESSARY ACTION ON CHANGE EVENTS
    //*******CREATED BY:PHANI KUMAR M
    //*******CREATED DATE: 6 TH JULY 2016
    //*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; **********************************
    $scope.commonDateSelectionYearGridOptions.change = function (e) {
        $scope.commonDateSelectionYearSelectedItem = [];
        //GETTING GRID OBJECT
        var grid = $scope.commonDateSelectionGridWidgets.grdCommonDateSelectionYearGridInfo;
        //GETTING SELECTED ITEM
        $scope.commonDateSelectionYearSelectedItem = grid.dataItem(grid.select());

        //CALLING METHOD TO GET SELECTED YEAR DETAILS
        $scope.commonDateSelectionGetSelectedMonthAndYearDetails(grid, true);
    };
    //######### YEAR SELECTION GRID CHANGE BLOCK END ##############
    //##################################################### YEAR SELECTION GRID BLOCK END ##########################################


    //######### DATE BUIDING ON MONTH OR YEAR  CANGE BLOCK START ##############
    //*******PURPOSE: THIS METHOD IS USED FOR DATE BUIDING ON MONTH OR YEAR  CANGE
    //*******CREATED BY:PHANI KUMAR M
    //*******CREATED DATE: 6 TH JULY 2016
    //*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; **********************************
    $scope.commonDateSelectionGetSelectedMonthAndYearDetails = function (SelectedGrid, IsYearGridSelected) {
        //IF ANY PREVIOUS ITEM SELECTED THEN REMOVING SELECTED ITEM AND ITS FOCUS
        if (hasValue($scope.PreviousSelectedItem) && hasValue($scope.PreviousSelectedItem.uid) && hasValue($scope.PreviousSelectedGrid) && $scope.PreviousSelectedItem.SelectionType != 4) {
            $scope.PreviousSelectedGrid.table.find("tr[data-uid='" + $scope.PreviousSelectedItem.uid + "']").removeClass("k-state-selected");//removing the state selected
            $scope.PreviousSelectedGrid.table.find("tr[data-uid='" + $scope.PreviousSelectedItem.uid + "']").children().removeClass("k-state-focused")//removing the state Focussed
            $scope.PreviousSelectedItem = [];
            $scope.PreviousSelectedGrid = {};

        }

        //DECLARING VARIABLES
        var commonDateSelectionSelectedDate = "";
        var commonDateSelectionSelectedDateDisplayText = "";
        var SelectionType = 0;
        //CHECKING WHETHER MONTH OR YEAR GRID SELECTED OR NOT
        if (hasValue(IsYearGridSelected) && IsYearGridSelected == false && !hasValue($scope.commonDateSelectionMonthSelectedItem) || !hasValue($scope.commonDateSelectionYearSelectedItem)) {
            $scope.PreviousSelectedMonthItem = $scope.commonDateSelectionMonthSelectedItem;
            $scope.PreviousSelectedMonthGrid = SelectedGrid;
            return;
        }

        //IF BOTYNAND YEAR SELECETED
        else if (hasValue($scope.commonDateSelectionMonthSelectedItem) && hasValue($scope.commonDateSelectionYearSelectedItem)) {
            //FORMING FULL DATE

            //if (hasValue($scope.commonDateSelectionMonthSelectedItem.MonthID) && $scope.commonDateSelectionMonthSelectedItem.MonthID < 10) {
            //    $scope.commonDateSelectionMonthSelectedItem.MonthID = "0" + $scope.commonDateSelectionMonthSelectedItem.MonthID;
            //}

            commonDateSelectionSelectedDate = $.format.date(new Date($scope.commonDateSelectionMonthSelectedItem.MonthID), "MM") + "/" + "01/" + $scope.commonDateSelectionYearSelectedItem.PreviousYear;
            //DISPLAY TEXT
            commonDateSelectionSelectedDateDisplayText = $.format.date(new Date($scope.commonDateSelectionMonthSelectedItem.MonthID), "MM") + "/" + $scope.commonDateSelectionYearSelectedItem.PreviousYear;
            SelectionType = 3;
        }
        //IF ONLY YEAR SELECTED
        else if (!hasValue($scope.commonDateSelectionMonthSelectedItem) && hasValue($scope.commonDateSelectionYearSelectedItem)) {
            //FORMING FULL DATE
            commonDateSelectionSelectedDate = "01/01/" + $scope.commonDateSelectionYearSelectedItem.PreviousYear;
            //DISPLAY TEXT
            commonDateSelectionSelectedDateDisplayText = $scope.commonDateSelectionYearSelectedItem.PreviousYear;
            SelectionType = 4;
        }

        var MonthOrYearSelectedData = {};

        if (hasValue($scope.$parent.EMRDataFromPopup) && (hasValue($scope.$parent.EMRDataFromPopup.isCallingFrom) && $scope.$parent.EMRDataFromPopup.isCallingFrom == "HMDUES" &&
            hasValue($scope.$parent.EMRDataFromPopup.isAllowFutureDate) && $scope.$parent.EMRDataFromPopup.isAllowFutureDate == true)) {

            //PASSING SELECTED DATA  AS RESUKT
            MonthOrYearSelectedData.SelectedDate = commonDateSelectionSelectedDate;
            MonthOrYearSelectedData.SelectedDateDisplayText = commonDateSelectionSelectedDateDisplayText;

        }
        else {
            if (hasValue($scope.$parent.EMRDataFromPopup) && hasValue($scope.$parent.EMRDataFromPopup.isAllowFutureDate) && $scope.$parent.EMRDataFromPopup.isAllowFutureDate == true) {

                if (DateDiff.inDays($.format.date(commonDateSelectionSelectedDate, "MM/dd/yyyy"), adminCurrentDateAndTme) >= 0) {
                    ShowErrorMessage("Next Due Date Should be Future Date.");


                    if (hasValue(IsYearGridSelected) && IsYearGridSelected == false) {
                        $scope.PreviousSelectedMonthItem = $scope.commonDateSelectionMonthSelectedItem;
                        $scope.PreviousSelectedMonthGrid = SelectedGrid;
                    }
                    else {
                        $scope.PreviousSelectedItem = $scope.commonDateSelectionYearSelectedItem;
                        $scope.PreviousSelectedGrid = SelectedGrid;

                    }
                    return false;
                }
            }

            else {
                //CHECKING WHETHER SELECTED DATE IS GREATER THAN CURRENT DATE OR NOT
                if ((DateDiff.inDays(new Date(commonDateSelectionSelectedDate), adminCurrentDateAndTme) < 0)
                    && !(_.get($scope, "$parent.EMRDataFromPopup.isFromAssestiveDevices") == "AssestiveDevisesUsageEndDate")) {
                    ShowErrorMessage("Future Date can't be Accepted.");


                    if (hasValue(IsYearGridSelected) && IsYearGridSelected == false) {
                        $scope.PreviousSelectedMonthItem = $scope.commonDateSelectionMonthSelectedItem;
                        $scope.PreviousSelectedMonthGrid = SelectedGrid;
                    }
                    else {
                        $scope.PreviousSelectedItem = $scope.commonDateSelectionYearSelectedItem;
                        $scope.PreviousSelectedGrid = SelectedGrid;

                    }
                    return false;
                }

                //CHECKING WHETHER SELECTED DATE IS GREATER THAN PATIENT DOB OR NOT
                var errorMessage = "";

                if (DateDiff.inDays($.format.date(commonDateSelectionSelectedDate, "MM/dd/yyyy"), $scope.commonDateSelectionPatientDOB) > 0) {

                    if (hasValue($scope.$parent.EMRDataFromPopup) && hasValue($scope.$parent.EMRDataFromPopup.IsDOBThere)) {

                        errorMessage = "Performed Date Should not be Less than Date of Birth."

                    } else {
                        errorMessage = "Start Date (or) Date of Onset Should not be Less than the Date of Birth.";
                    }


                    if (hasValue($scope.$parent.EMRDataFromPopup) && hasValue($scope.$parent.EMRDataFromPopup.isCallingFrom) && $scope.$parent.EMRDataFromPopup.isCallingFrom == "HMDUES") {

                        // if it is calling from Reminder Dues
                        errorMessage = "Status Date Should not be Less than Date of Birth (" + $scope.commonDateSelectionPatientDOB + ").";
                    }


                    ShowErrorMessage(errorMessage);

                    if (hasValue(IsYearGridSelected) && IsYearGridSelected == false) {
                        $scope.PreviousSelectedMonthItem = $scope.commonDateSelectionMonthSelectedItem;
                        $scope.PreviousSelectedMonthGrid = SelectedGrid;
                    }
                    else {
                        $scope.PreviousSelectedItem = $scope.commonDateSelectionYearSelectedItem;
                        $scope.PreviousSelectedGrid = SelectedGrid;

                    }
                    return false;
                }
            }

            //PASSING SELECTED DATA  AS RESUKT
            MonthOrYearSelectedData.SelectedDate = commonDateSelectionSelectedDate;
            MonthOrYearSelectedData.SelectedDateDisplayText = commonDateSelectionSelectedDateDisplayText;

        }
        formatSelectedValueAndClose(MonthOrYearSelectedData); //Format the selected value and pass as parameter when closing popup
    };
    //######### DATE BUIDING ON MONTH OR YEAR  CANGE BLOCK END ##############


    //######### CALENDER SELECTION BLOCK START ##############
    //*******PURPOSE: THIS METHOD IS USED  TO SELECT DATE FORM CALENDER
    //*******CREATED BY:PHANI KUMAR M
    //*******CREATED DATE: 6 TH JULY 2016
    //*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; **********************************
    $scope.commonDateSelectionCalendarOnChange = function () {
        //IF NO DATE SELECTED THEN RETURN
        if (!hasValue($scope.commonDateSelectionSelectDate)) return;

        var CalenderSelectedData = {};

        if (hasValue($scope.$parent.EMRDataFromPopup) && (hasValue($scope.$parent.EMRDataFromPopup.isCallingFrom) && $scope.$parent.EMRDataFromPopup.isCallingFrom == "HMDUES" &&
            hasValue($scope.$parent.EMRDataFromPopup.isAllowFutureDate) && $scope.$parent.EMRDataFromPopup.isAllowFutureDate == true)) {

            //PASSING SELECTED DETAILS AS RESULT
            CalenderSelectedData.SelectedDate = $scope.commonDateSelectionSelectDate;
            CalenderSelectedData.SelectionType = 5;

        }
        else {

            if (hasValue($scope.$parent.EMRDataFromPopup) && hasValue($scope.$parent.EMRDataFromPopup.isAllowFutureDate) && $scope.$parent.EMRDataFromPopup.isAllowFutureDate == true) {

                //IF SELECTED DATE IS FUTURE DATE THEN RETURN
                if (DateDiff.inDays($.format.date($scope.commonDateSelectionSelectDate, "MM/dd/yyyy"), adminCurrentDateAndTme) >= 0) {
                    ShowErrorMessage("Next Due Date Should be Future Date.");
                    return false;
                }

            }
            else {
                //IF SELECTED DATE IS FUTURE DATE THEN RETURN
                if ((DateDiff.inDays($scope.commonDateSelectionSelectDate, adminCurrentDateAndTme) < 0)
                    && !(_.get($scope, "$parent.EMRDataFromPopup.isFromAssestiveDevices") == "AssestiveDevisesUsageEndDate")) {
                    ShowErrorMessage("Future Date can't be Accepted.");
                    return false;
                }

                //IF SELECTED DATA IS GREATER THAN PATIENT DOB
                if (DateDiff.inDays($.format.date($scope.commonDateSelectionSelectDate, "MM/dd/yyyy"), $scope.commonDateSelectionPatientDOB) > 0) {

                    var errorMessage = "";

                    if (hasValue($scope.$parent.EMRDataFromPopup) && hasValue($scope.$parent.EMRDataFromPopup.IsDOBThere)) {

                        errorMessage = "Performed Date Should not be Less than the Date of Birth."

                    } else {
                        errorMessage = "Start Date (or) Date of Onset Should not be Less than the Date of Birth.";
                    }

                    if (hasValue($scope.$parent.EMRDataFromPopup) && hasValue($scope.$parent.EMRDataFromPopup.isCallingFrom) && $scope.$parent.EMRDataFromPopup.isCallingFrom == "HMDUES") // if it is calling from Reminder Dues
                        errorMessage = "Status Date Should not be Less than Date of Birth (" + $scope.commonDateSelectionPatientDOB + ").";

                    ShowErrorMessage(errorMessage);
                    return false;
                }
            }
            //PASSING SELECTED DETAILS AS RESULT
            CalenderSelectedData.SelectedDate = $scope.commonDateSelectionSelectDate;
            CalenderSelectedData.SelectionType = 5;
        }
        formatSelectedValueAndClose(CalenderSelectedData); //Format the selected value and pass as parameter when closing popup
    }
    //######### CALENDER SELECTION BLOCK END ##############

    //################### CLOSE CURRENT WINDOW POPUP BLOCK START #############################
    ///*******PURPOSE:  This Method is used to close current popup
    ///*******CREATED BY: Rama M
    ///*******CREATED DATE:07/05/2016
    ///*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; *************************
    $scope.commonDateSelectionCancelEvent = function () {
        if(_.get($scope.$parent.EMRDataFromPopup,"isPopupOpenedFrom") == "PL") EMRCommonFactory.EHRSaveAuditLogInformation(EHRAuditLogXperEMR_Components.ProblemList, "Select Date Popup from PL", "Select Date Popup Closed", EHRAuditLogStatus.Success, EHRAuditLogActions.WINDOWCLOSE, _.get($scope.$parent.EMRDataFromPopup,"PatientID"), EMRPracticeModel.LoggedUserID);
        $scope.$parent.CancelWithEvent();
    }
    //################### CLOSE CURRENT WINDOW POPUP BLOCK END #############################


    //################### MAXIMIZE POPUP BLOCK START #############################
    ///*******PURPOSE:  This Method is used to close current popup
    ///*******CREATED BY: Rama M
    ///*******CREATED DATE:07/05/2016
    ///*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; *************************
    $scope.commonDateSelectionMaximizeClickEvent = function ($event) {
        $scope.$parent.Maximize($event);
    };

    //################### MAXIMIZE POPUP BLOCK END #############################

    //did  changes to set the UI according to the font size
    //anusha ch
    if (hasValue(EMRPracticeModel.practicesettingsmodel.EHRApplicationSettingsFontSize == 9)) {
        $("#spnCommonDateSelectionCalendar").css("height", "252px !important");
    }
    /**
     * @author Prasanna.K
     * @since 08/05/2022
     * @param {Object} selectedDateDetails 
     * @description Used to format the selected date details
     * This function gets the soft date which is date in string format
     * and
     * also gets the hard date which is formatted date and send in closing
     */
    function formatSelectedValueAndClose(selectedDateDetails) {
        selectedDateDetails.dateInString = buildSoftDate(selectedDateDetails);
        selectedDateDetails.formattedDate = buildFormattedDate(selectedDateDetails);
        if(_.get($scope.$parent.EMRDataFromPopup,"isPopupOpenedFrom") == "PL") EMRCommonFactory.EHRSaveAuditLogInformation(EHRAuditLogXperEMR_Components.ProblemList, "Select Date Popup from PL", "Date Selected Successfully", EHRAuditLogStatus.Success, EHRAuditLogActions.ADDITION, _.get($scope.$parent.EMRDataFromPopup,"PatientID"), EMRPracticeModel.LoggedUserID);
        $scope.$parent.OK(selectedDateDetails);
    }
    /**
     * @author Prasanna.K
     * @since 08/05/2022
     * @param {Object} selectedDateDetails 
     * @returns date in string format
     * @description This function formats the date as needed based on the selected date format
     * If user selects full date, we will format it like "MM/dd/yyyy"
     * Otherwise, we will assign as is
     */
    function buildSoftDate(selectedDateDetails) {
        if (selectedDateDetails && (selectedDateDetails.SelectionType == 1 || selectedDateDetails.SelectionType == 5) && selectedDateDetails.SelectedDate) {
            return new Date(selectedDateDetails.SelectedDate.toString()).getFormat("MM/dd/yyyy");
        }
        else
            return selectedDateDetails.SelectedDateDisplayText;
    }
    /**
     * @author Prasanna.K
     * @since 08/05/2022
     * @param {Object} selectedDateDetails 
     * @returns date in string format
     * @description This function formats the date as needed based on the selected date format
     * If user selects only year, we will format the date as "MM/dd/yyyy" format by considering 
     * the month as "06" and date as "15" as qa wants to consider middle of year and middle of month
     * Ex: If user selcts 2022 format in the common date popup, we will format as "06/15/2022"
     * If user selects month and year, for example, "07/2022", we will format it as by appending date to this
     * 07/15/2022
     * If we get the full date we will format the same and date and return
     */
    function buildFormattedDate(selectedDateDetails) {
        if (selectedDateDetails.dateInString) {
            let dateParts = [];
            dateParts = selectedDateDetails.dateInString.toString().split("/");
            if (dateParts && dateParts.length == 2)
                return new Date(`${dateParts[0]}/15/${dateParts[1]}`).getFormat("MM/dd/yyyy");
            else if (dateParts && dateParts.length == 1)
                return new Date(selectedDateDetails.dateInString.toString()).getFormat("06/15/yyyy");
            else
                return new Date(selectedDateDetails.dateInString.toString()).getFormat("MM/dd/yyyy");
        }
    }
    //Page Init End
    //$scope.commonDateSelectionPageInit();
}]);